import { createFileRoute } from "@tanstack/react-router"

import { requirePermission } from "@/lib/route-guards"
import { Perm } from "@/lib/permissions"
import { ProjectSelectionsPage } from "@/pages/projects/project-selections-page"

export const Route = createFileRoute("/_authenticated/projects/$id/selections")({
	beforeLoad: async ({ context }) => {
		await requirePermission(context, Perm.PROJECT_READ, { to: "/projects" })
	},
	component: ProjectSelectionsPage
})
